import type { SVGProps } from 'react';

const SvgTrigger = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="trigger">
      <path d="M11.28 31.63a.7.7 0 0 0 .39.11.75.75 0 0 0 .54-.22l16.64-17a.72.72 0 0 0 .16-.81.75.75 0 0 0-.69-.46h-9.43l4.37-11.81a.74.74 0 0 0-.09-.69.75.75 0 0 0-.61-.32h-9.91a.75.75 0 0 0-.7.49L5.71 18.14a.75.75 0 0 0 .7 1h8.48L11 30.75a.75.75 0 0 0 .28.88Zm5.37-13a.75.75 0 0 0-.1-.68.77.77 0 0 0-.61-.31H7.48l5.7-15.71h8.3l-4.37 11.85a.77.77 0 0 0 .09.69.75.75 0 0 0 .61.32h8.72l-13.1 13.34ZM21.674 26.698l1.295-.756 2.344 4.017-1.296.756zM25.064 23.36l.321-1.466 4.581 1.006-.321 1.465zM4.269 2.092 5.37 1.076l3.057 3.316-1.103 1.016zM1.35 8.25H5.9v1.5H1.35z" />
    </g>
  </svg>
);

export default SvgTrigger;
